export const styles = (theme) => ({
  drawer: {
    width: 240,
    flexShrink: 0,
    backgroundColor: "#F3F3F3"
  },
  drawerPaper: {
    width: 240,
    borderRight:0,
    backgroundColor: "#F3F3F3",
  },
});
